
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trademark-search-services/[slug]",
      function () {
        return require("private-next-pages/trademark-search-services/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trademark-search-services/[slug]"])
      });
    }
  